import { ErrorStateMatcher } from '@angular/material/core';
import {
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  AbstractControl,
  FormControl,
  FormGroupDirective,
  NgForm,
} from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';
// import { parsePhoneNumberFromString, parse } from 'libphonenumber-js';

// form validator
export function ValidatorPasswordConfirm(option?: {
  formName?: string;
  passwordFieldName?: string;
  passwordConfirmFieldName?: string;
}): ValidatorFn {
  let formName = '';
  let passwordFieldName = 'password';
  let passwordConfirmFieldName = 'passwordConfirm';

  if (option && option.formName) {
    formName = option.formName;
  }
  if (option && option.passwordFieldName) {
    passwordFieldName = option.passwordFieldName;
  }
  if (option && option.passwordConfirmFieldName) {
    passwordConfirmFieldName = option.passwordConfirmFieldName;
  }

  return (control: FormGroup): ValidationErrors | null => {
    const password = control && control.get(passwordFieldName).value;
    const passwordConfirm = control && control.get(passwordConfirmFieldName).value;

    if (password === passwordConfirm) {
      return null;
    } else {
      const validatorJson = {};
      if (formName) {
        validatorJson[`${formName}.${passwordConfirmFieldName}`] = true;
      } else {
        validatorJson[passwordConfirmFieldName] = true;
      }
      return validatorJson;
    }
  };
}
